import request from '../api/request'

function get(id) {
    return request({
        url:    `/ticket_type/${id}.json`,
        method: 'GET'
    });
}

function index() {
    return request({
        url:    `/ticket_type/all.json`,
        method: 'GET'
    });
}

function update(id, data) {
    return request({
        url:    `/ticket_type/${id}.json`,
        method: 'PUT',
        data: data
    });
}

function create({data}) {
    return request({
        url:    `/ticket_type.json`,
        method: 'POST',
        data:   data
    });
}

const TicketTypeApiService = {
    index, get, create, update //, update, delete, etc. ...
};

export default TicketTypeApiService;